var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66797 3.33333C6.29978 3.33333 6.0013 3.63181 6.0013 4V4.66406H10.0013V4C10.0013 3.63181 9.70283 3.33333 9.33464 3.33333H6.66797ZM4.66797 4V4.66406H4C2.89543 4.66406 2 5.55949 2 6.66406V11.9974C2 13.102 2.89543 13.9974 4 13.9974H12C13.1046 13.9974 14 13.102 14 11.9974V6.66406C14 5.55949 13.1046 4.66406 12 4.66406H11.3346V4C11.3346 2.89543 10.4392 2 9.33464 2H6.66797C5.5634 2 4.66797 2.89543 4.66797 4ZM7.33333 8.0026C7.33333 7.63441 7.63181 7.33594 8 7.33594C8.36819 7.33594 8.66667 7.63441 8.66667 8.0026V8.66927H9.33333C9.70152 8.66927 10 8.96775 10 9.33594C10 9.70413 9.70152 10.0026 9.33333 10.0026H8.66667V10.6693C8.66667 11.0375 8.36819 11.3359 8 11.3359C7.63181 11.3359 7.33333 11.0375 7.33333 10.6693V10.0026H6.66667C6.29848 10.0026 6 9.70413 6 9.33594C6 8.96775 6.29848 8.66927 6.66667 8.66927H7.33333V8.0026Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCase);
export default __webpack_public_path__ + "static/media/medical-case.3cc22b9b4a0eab3617f042b0618b4f46.svg";
export { ForwardRef as ReactComponent };